<template>
	<div class="popBox" id="popBox" @touchmove.prevent>
		<div class="payMsg">
			<img class="offpop" @click="offPop()" src="../../assets/offpop.png"/>
			<p class="popTip1">温馨提示</p>
			<p class="popTip2" v-text="summary[audiopay].name"></p>
			<p v-for="(item,index) in bookOrjie" class="popTip3" @click="tobuy(item)" :key="index">{{item.popname}}￥{{item.price}}/{{item.jifen}}积分</p>
		</div>
	</div>
</template>
<script>
import payWays from "./payWays.vue";
import common from "../../common.js";
export default {
  name: "payPop",
  data() {
    return {
      summary: {
        videoSum: {
          name: "付费课程需购买才能播放！"
        },
        audioSum: {
          name: "购买整个课程才能播放！"
        }
      }
    };
  },
  methods: {
    offPop: function () {
      this.$emit("offPopchild");
      common.move();
    },
    tobuy: function (Obj) {
      this.$emit("offPopchild1", Obj);
    }
  },
  components: {
    payWays
  },
  props: ["popMsg", "videopay", "bookOrjie", "audiopay"]
};
</script>
<style lang="scss" scoped>
.popBox {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  .payMsg {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 560px;
    height: 502px;
    margin: -251px 0 0 -280px;
    font-size: 28px;
    color: #666;
    text-align: center;
    background: url(../../assets/paypopbg.png) no-repeat;
    background-size: 100% 100%;
    .popTip1 {
      margin: 148px 0 24px;
      font-size: 36px;
      font-weight: bold;
      color: #333;
    }
    .popTip3 {
      background: url(../../assets/poptipbg.png) no-repeat;
      background-size: 100% 100%;
      width: 500px;
      height: 80px;
      line-height: 80px;
      color: #fff;
      font-size: 30px;
      margin: 30px auto;
    }
    .offpop {
      position: absolute;
      top: 90px;
      right: 28px;
      width: 32px;
      height: 32px;
    }
  }
}
</style>
